import ScrollTracking from './ScrollTracking';

export default ScrollTracking;
